import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmBellRing = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "alarm-bell-ring" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.814,4.266a6.35,6.35,0,0,0-2.47,2.471"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.975,1.5A6.5,6.5,0,0,0,1.5,5.976"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.5,
			y1: 18,
			x2: 19.5,
			y2: 18
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.5,18S18,16.694,18,12c0-3.75-2.562-7.068-6-7.068S6,8.25,6,12c0,4.719-1.5,6-1.5,6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.5,21a1.5,1.5,0,0,1-3,0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 4.932,
			x2: 12,
			y2: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.186,4.266a6.456,6.456,0,0,1,1.408,1.062,6.391,6.391,0,0,1,1.062,1.409"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.025,1.5A6.5,6.5,0,0,1,22.5,5.976"
		})
	]
});
export default SvgAlarmBellRing;
